module.exports = __webpack_public_path__ + "static/avensis-832480d652e7cc27f8686de06b944164.png";